import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../core/api/apiTypes"
import { SalesAccount, SalesAccountBase, SalesAccountCreate } from "./salesAccountsTypes"

export enum SalesAccountsQuery {
    LIST = "sales-accounts-for-merchant",
    DETAILS = "sales-account-for-merchant",
}

type SalesAccountsParam = Readonly<{
    merchantId: number
}>

export type SalesAccountsResponse = Readonly<{
    salesAccounts: SalesAccount[]
}>

export async function fetchSalesAccounts(
    { merchantId }: SalesAccountsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SalesAccountsResponse> {
    const url = `/merchants/${merchantId}/salesAccount`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type DeleteSalesAccountParams = Readonly<{
    salesAccountId: number
}>

export async function deleteSalesAccount(
    { salesAccountId }: DeleteSalesAccountParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/salesAccount/${salesAccountId}`, {
        signal,
    })
    return data
}

type SalesAccountDetailsParam = Readonly<{
    salesAccountId: string
}>

export type SalesAccountDetailsResponse = Readonly<{
    salesAccount: SalesAccountBase
}>

export async function salesAccountDetails(
    { salesAccountId }: SalesAccountDetailsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SalesAccountDetailsResponse> {
    const url = `/salesAccount/${salesAccountId}`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type CreateSalesAccountParam = Readonly<{
    salesAccount: SalesAccountCreate
}>

export async function createSalesAccount(
    { salesAccount }: CreateSalesAccountParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/salesAccount`,
        {
            salesAccount,
        },
        {
            signal,
        },
    )
    return data
}

type UpdateSalesAccountParam = Readonly<{
    salesAccountId: string
    salesAccount: SalesAccountBase
}>

export async function updateSalesAccount(
    { salesAccountId, salesAccount }: UpdateSalesAccountParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/salesAccount/${salesAccountId}`,
        {
            salesAccount,
        },
        {
            signal,
        },
    )
    return data
}
